/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { HintField, LabelField } from "components";
import { getIn } from "formik";
import React, { memo, useEffect, useRef } from "react";
import "./style.scss";
import { fontConfig } from "theme/fontConfig";

export const InputFieldWithCheckbox = memo(
  ({
    setFieldsData,
    memberInfo,
    title,
    name,
    useref,
    style,
    formStyle,
    type,
    step,
    rules,
    placeholderIcon,
    error,
    formik,
    checkValidation = false,
    mandatory = false,
    handleChange,
    setOpenKeyboard,
    openKeyboard,
    inputClassName,
    min,
    onClick,
    onKeyDown,
    batchreview,
    className,
    paymentInput,
    titleStyle,
    checkbox,
    checkedBox,
    checkboxChange,
    checkboxLabel,
    ...rest
  }) => {
    const ref = useRef(null);
    useEffect(() => {
      if (useref) ref.current.focus();
    }, []);

    const getInputClasses = () => {
      if (!checkValidation) {
        return "";
      }

      const touched = getIn(formik?.touched, name);
      const error = getIn(formik?.errors, name);

      if (touched && error) {
        return "is-invalid";
      }

      if (touched && !error) {
        return "is-valid";
      }

      return "";
    };
    return (
      <div
        className={
          memberInfo
            ? `form-group fv-plugins-icon-container  member-info-form`
            : batchreview
            ? `form-group fv-plugins-icon-container batchreview `
            : paymentInput === "paymentInput"
            ? `form-group fv-plugins-icon-container payment-methods-input`
            : title === `none`
            ? `form-group fv-plugins-icon-container ledger-name-input`
            : `form-group fv-plugins-icon-container mb-0`
        }
        style={{ ...formStyle }}
      >
         <div
            className="d-flex align-items-center justify-content-between"
            style={{ height: '27px' }}
          >
        <div className="d-flex">
          <LabelField
            className={memberInfo ? 'member-info-date-lable' : ''}
            htmlFor={name}
            title={title}
            mandatory={mandatory}
            style={{
              fontFamily: fontConfig.GeneralMemberInfoDateLableFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
              ...titleStyle,
            }}
          />
        </div>
        {checkbox && (
          <div className="col-sm-6 d-flex justify-content-end align-items-center p-0 mb-2">
            <div className="col d-flex justify-content-end text-nowrap">
              {checkboxLabel}
            </div>
            <FormControlLabel
              control={
                <Switch
                  checked={checkedBox}
                  onChange={checkboxChange}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              }
              style={{ margin: '0px' }}
            />
          </div>
        )}
        </div>
        <form
          className="d-flex"
          style={{
            background: style?.background ? style?.background : "#F3F6F9",
            borderRadius: "6px",
          }}
        >
          <input
            ref={ref}
            onWheel={(e) => e.target.blur()}
            style={
              paymentInput
                ? {
                    ...style,
                    height: "48px",
                    fontFamily: fontConfig.GeneralFormControlSolidFont.family,
                    fontSize: "14px",
                    fontWeight: "700",
                  }
                : { height: "48px", ...style }
            }
            id={name}
            type={type}
            min={min}
            step={step}
            onKeyDown={onKeyDown}
            disabled={rest?.disabled}
            className={`form-control form-control-solid py-5 px-6 ${getInputClasses()} ${inputClassName} `}
            {...rest}
            {...formik?.getFieldProps(name)}
            onChange={handleChange ?? formik?.handleChange}
            value={rest.value}
            autoComplete="off"
            onClick={rest?.handleFocus}
          />
          {placeholderIcon}
        </form>

        {checkValidation && getIn(formik?.touched, name) && getIn(formik?.errors, name) ? (
          <HintField error={getIn(formik?.errors, name)} />
        ) : null}
      </div>
    );
  }
);
